import { useState } from 'react'
import { httpsCallable } from 'firebase/functions'
import { functions } from '@/lib/firebase'
import { getTimezonePreference, setTimezone as saveTimezone, getTimezone } from '@/lib/dateTime'

export function useTimezone() {
  const [timezone, setTimezoneState] = useState(getTimezonePreference)

  const setTimezone = (tz: string) => {
    saveTimezone(tz)
    setTimezoneState(tz)

    // Persist the resolved IANA timezone to the user's Firestore profile
    // so server-side features (e.g. Telegram alerts) can use it.
    const resolvedTz = tz === 'browser' ? getTimezone() : tz
    const updateUserTimezone = httpsCallable(functions, 'updateUserTimezone')
    updateUserTimezone({ timezone: resolvedTz }).catch((err) => {
      console.error('Failed to save timezone to profile:', err)
    })

    window.location.reload()
  }

  return { timezone, setTimezone }
}
